<template lang="pug">
section
  .blocks
    .block(v-for="(block, i) of blocks" :key="'block_' + i" :class="{'opened': block.opened}")
      h3(@click="block.opened = !block.opened") {{ block.name }}
      .block-content
        .content(v-for="l of block.list")
          .title(v-if="l.key") {{ l.key }}:
          ul.list
            li(v-for="item of l.items")
              span {{ item }}


</template>

<script>
import {mainBlocks} from '@/contents/services'

export default {
  name: "Home",
  data() {
    return {
      blocks: {}
    }
  },
  mounted() {
    this.blocks = mainBlocks
  }
}
</script>

<style scoped>

</style>
